import React, { createContext, useContext, useState } from 'react';
import { CreditCardResponse2 } from '../model/Credit-card.model';

interface CardDetailContextType {
  selectedCard: CreditCardResponse2 | null;
  setSelectedCard: (card: CreditCardResponse2 | null) => void;
  maturityScheduleId?: number;
  setMaturityScheduleId: (id: number | undefined) => void;
  maturityYear?: number;
  setMaturityYear: (year: number | undefined) => void;
}

const CardDetailContext = createContext<CardDetailContextType | undefined>(
  undefined
);

export const CardDetailProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedCard, setSelectedCard] = useState<CreditCardResponse2 | null>(
    null
  );
  const [maturityScheduleId, setMaturityScheduleId] = useState<number>();
  const [maturityYear, setMaturityYear] = useState<number>();

  return (
    <CardDetailContext.Provider
      value={{
        selectedCard,
        setSelectedCard,
        maturityScheduleId,
        setMaturityScheduleId,
        maturityYear,
        setMaturityYear,
      }}
    >
      {children}
    </CardDetailContext.Provider>
  );
};

export const useCardDetail = () => {
  const context = useContext(CardDetailContext);
  if (context === undefined) {
    throw new Error('useCardDetail must be used within a CardDetailProvider');
  }
  return context;
};
